import Timestamp from "components/Timestamp";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Session } from "types/generated";

const SessionsTableExpiresAtCell = ({
  item: session,
  ...cellProps
}: TableSimpleCellProps<Pick<Session, "expiresAt">>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <Timestamp variant="p-body3" timestamp={session.expiresAt} />
    </TableSimpleCell>
  );
};

export default SessionsTableExpiresAtCell;
